<template>
  <div class="catering-item">
    <div class="logo">
      <img :src="info.logo">
    </div>
    <div class="info-name">{{info.name}}</div>
    <div>
      <van-button @click="routerTo" round color="#9774E1" size="small">立即点餐</van-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CateringList',
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    routerTo () {
      window.location.href = this.info.url
    }
  }
}
</script>
<style lang="scss" scoped>
.catering-item{
  @include flex();
  background: #fff;
  margin: 0.1rem auto;
  width: 6.8rem;
  padding: 0.15rem;
  border-radius: 5px;
  .info-name{
    height: 1.5rem;
    width: 3.5rem;
    font-size: $text-size-larger;
    font-weight: 600;
    @include Textover();
  }
  .logo {
    width: 1.5rem;
    height: 1.5rem;
  }
}
</style>